'use client'

import { useId } from 'react'

interface ActivityIndicatorProps {
  size?: number
  className?: string
}

export function ActivityIndicator({ size = 48, className = '' }: ActivityIndicatorProps) {
  const id = useId()

  return (
    <span
      className={`inline-flex items-center justify-center text-primary ${className}`}
      style={{ width: size, height: size }}
      aria-label="loading"
      role="status"
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="animate-spin"
        style={{ display: 'block', animationDuration: '1.4s' }}
      >
        <defs>
          <mask id={`${id}-cut`}>
            <rect width="128" height="128" fill="white" />
            <circle cx="29" cy="34" r="24" fill="black" />
          </mask>
        </defs>
        {/* Large orbit ring — the open arc acts as the spinner gap */}
        <circle
          cx="64" cy="64" r="44"
          stroke="currentColor"
          strokeWidth="16"
          fill="none"
          mask={`url(#${id}-cut)`}
        />
        {/* Satellite circle at the gap */}
        <circle
          cx="29" cy="34" r="14"
          stroke="currentColor"
          strokeWidth="16"
          fill="none"
        />
      </svg>
    </span>
  )
}
